import {
  hasResolvedDocumentValue,
  useDocument,
} from "@shared/components/providers/SupergrainProvider"
import type { UnifiedCardStack } from "@shared/models/card-stack"
import UnifiedTemplateEditor from "../components/planner/card-stacks/UnifiedTemplateEditor"

interface Props {
  cardStack: UnifiedCardStack & { attributes: { usedAs: "lesson-template" } }
  /** Distinguishes the wrapper styling between the surfaces a template is edited in. */
  className?: string
  /**
   * When provided, shows a "Delete Template" option that calls this on click.
   * Templates in the course-creation flow omit it.
   */
  onDelete?: () => void
}

/**
 * Adapts the Ember card-stack model passed from the template-editing Ember components
 * into a supergrain document, then renders the framework-agnostic UnifiedTemplateEditor.
 */
export default function TemplateEditorIsland({ cardStack, className, onDelete }: Props) {
  // The Ember model is a carrier for an id; read the supergrain copy by id.
  const cardStackHandle = useDocument("card-stack", cardStack.id)

  if (cardStackHandle.status === "error") throw cardStackHandle.error
  if (!hasResolvedDocumentValue(cardStackHandle)) return null

  return (
    <UnifiedTemplateEditor
      // The handle types by document type; the props already narrowed this id to a template.
      cardStack={cardStackHandle.value as Props["cardStack"]}
      className={className}
      onDelete={onDelete}
    />
  )
}
